import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {Observable} from "rxjs/Rx";
import {User} from "../../model/user";
import {AccessToken} from "../../model/access-token";
import {UrlService} from "../url.service";
import {AuthentService} from "../authent.service";
import {FamiliesService} from "../families.service";

@Injectable()
export class UserService extends FamiliesService {

    constructor(private http:Http, private urlService:UrlService, private authent:AuthentService) {
        super();
    }

    getToken(email:string, password:string):Observable<AccessToken> {
        let url = this.urlService.getAuthentUrl() + '?grant_type=password' + '&username=' + email + '&password=' + password;

        return this.http.get(url, this.authent.getAnonymousHeaders())
            .map(this.extractData)
            .catch(this.handleError);
    }

    getPrincipal():Observable<User> {
        return this.http.get(this.urlService.getPrincipalUrl(), this.authent.getJSONAuthentHeaders())
            .map(this.extractData)
            .catch(this.handleError);
    }

    getEventMembers(eventId:number):Observable<User[]> {
        return this.http.get(this.urlService.getEventMembersUrl(eventId), this.authent.getJSONAuthentHeaders())
            .map(this.extractData)
            .catch(this.handleError);
    }

    register(subscriptionModel:any) {
        return this.http.post(this.urlService.getRegisterUrl(), subscriptionModel, this.authent.getJSONAuthentHeaders())
            .map(this.extractData)
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/data/user.service.ts